import { supabase } from '../lib/supabase';
import { subscribeToRestaurantChanges } from '../utils/realtimeSubscription';

const requireRestaurantId = (restaurantId) => {
  if (!restaurantId) {
    throw new Error('Restaurant context is required');
  }
};

// ─── Promotions ───────────────────────────────────────────────────────────────

export const fetchPromotions = async (activeOnly = false, restaurantId) => {
  requireRestaurantId(restaurantId);
  let query = supabase?.from('promotions')?.select('*')?.eq('restaurant_id', restaurantId);
  query = query?.order('sort_order', { ascending: true });
  if (activeOnly) {
    query = query?.eq('active', true);
  }
  const { data, error } = await query;
  if (error) throw error;
  return data?.map(dbPromoToApp);
};

export const addPromotion = async (promo, restaurantId) => {
  requireRestaurantId(restaurantId);
  const { data: existing } = await supabase?.from('promotions')?.select('sort_order')?.eq('restaurant_id', restaurantId)
    ?.order('sort_order', { ascending: false })
    ?.limit(1)
    ?.single();
  const sortOrder = (existing?.sort_order || 0) + 1;

  const payload = {
    title: promo?.title || '',
    description: promo?.description || '',
    image_url: promo?.imageUrl || '',
    sort_order: sortOrder,
    active: promo?.active !== undefined ? promo?.active : true,
    updated_at: new Date()?.toISOString(),
  };
  payload.restaurant_id = restaurantId;

  const { data, error } = await supabase?.from('promotions')?.insert(payload)?.select()?.single();
  if (error) throw error;
  return dbPromoToApp(data);
};

export const updatePromotion = async (id, promo, restaurantId) => {
  requireRestaurantId(restaurantId);
  const payload = {
    title: promo?.title || '',
    description: promo?.description || '',
    image_url: promo?.imageUrl || '',
    active: promo?.active !== undefined ? promo?.active : true,
    updated_at: new Date()?.toISOString(),
  };
  const { error } = await supabase?.from('promotions')?.update(payload)?.eq('id', id)?.eq('restaurant_id', restaurantId);
  if (error) throw error;
};

export const deletePromotion = async (id, restaurantId) => {
  requireRestaurantId(restaurantId);
  const { error } = await supabase?.from('promotions')?.delete()?.eq('id', id)?.eq('restaurant_id', restaurantId);
  if (error) throw error;
};

export const subscribeToPromotions = (callback, restaurantId) => {
  return subscribeToRestaurantChanges({
    channelName: 'promotions_changes',
    table: 'promotions',
    restaurantId,
    callback,
  });
};

// ─── Converter ────────────────────────────────────────────────────────────────

function dbPromoToApp(d) {
  return {
    id: d?.id,
    title: d?.title || '',
    description: d?.description || '',
    imageUrl: d?.image_url || '',
    sortOrder: d?.sort_order || 0,
    active: d?.active !== false,
    createdAt: d?.created_at,
    updatedAt: d?.updated_at,
  };
}
